import { StoreLoading } from '../types';
import {
  PromocodeStatus,
  PromocodeStoreState,
  PromocodeValue
} from './types';

type PromocodeSelectors = {
  selectLoading: (
    state: PromocodeStoreState
  ) => StoreLoading;
  selectAppliedStatus: (
    state: PromocodeStoreState
  ) => PromocodeStatus;
  selectPromocode: (
    state: PromocodeStoreState
  ) => PromocodeValue;
};

export default {
  selectLoading: (state) => state.loading,

  selectAppliedStatus: (state) =>
    !state.entity
      ? 'empty'
      : state.entity.status
        ? 'applied'
        : 'failed',

  selectPromocode: (state) => state.entity?.value || ''
} as PromocodeSelectors;
